<template>
	<div class="index app" :style="{ backgroundImage: `url(${currentImage})` }" ref="info">
		<!-- <HeaderLayer :logo-img="require('@/assets/image/logo/logo.png')" :font-color="'#333333'"></HeaderLayer> -->
		<HeaderLayer :tab-nav-index="1"></HeaderLayer>
		<div class="main-content">
			<div class="hero">
				<div class="a">聚专技英才之力 破关键技术瓶颈</div>
				<div class="a">夯实现代化建设人才底座</div>
				<div class="c" @click="toLogin()">开启学习之旅</div>
			</div>
		</div>

		<!-- <div class="d" v-if="showVideo">
			<video ref="video" class="video" src="@/assets/video/video.mp4"
				poster="@/assets/image/big_version/main/bb.jpg" autoplay muted loop></video>
			<i @click="play()" v-if="isPlay" class="el-icon-video-pause hid"></i>
			<i @click="play()" v-else class="el-icon-video-play hid"></i>
			<img src="@/assets/image/big_version/main/exit.png" @click="notShowVideo()" />
		</div> -->

		<!-- 平台 -->
		<!-- <div class="project">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide projectItem" v-for="(system, index) in subSystemArr" :key="index"
						@mouseover="handleMouseEnter" @mouseout="handleMouseLeave"
						:style="{ backgroundImage: 'url(' + system.subsysMainPic + ')' }">
						<div>
							<span>{{ system.subsysName }}</span>
						</div>
						<div>
							<img :src="system.subsysMainLogo" />
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!-- <div class="tip">
			<TipsLayer></TipsLayer>
		</div> -->
		<!-- 购买流程 -->
		<div class="buyProcess">
			<div class="buyProcessTitle">购买<br>流程</div>
			<div class="buyProcessContent">
				<div class="buy-item">
					<div class="icon-img"><img src="@/assets/image/buyProcess/icon1.png" /></div>
					<div>
						<div class="title">01-注册登录</div>
						<p>实名注册专属账号</p>
					</div>
				</div>
				<div class="fg">
					<img src="@/assets/image/buyProcess/angela.png" />
				</div>
				<div class="buy-item">
					<div class="icon-img"><img src="@/assets/image/buyProcess/icon2.png" /></div>
					<div>
						<div class="title">02-缴费选课</div>
						<p>智能推荐优质课程</p>
					</div>
				</div>
				<div class="fg">
					<img src="@/assets/image/buyProcess/angela.png" />
				</div>
				<div class="buy-item">
					<div class="icon-img"><img src="@/assets/image/buyProcess/icon3.png" /></div>
					<div>
						<div class="title">03-在线学习</div>
						<p>线上学习更轻松</p>
					</div>
				</div>
				<div class="fg">
					<img src="@/assets/image/buyProcess/angela.png" />
				</div>
				<div class="buy-item">
					<div class="icon-img"><img src="@/assets/image/buyProcess/icon4.png" /></div>
					<div>
						<div class="title">04-学时证明</div>
						<p>一人一档永久有效</p>
					</div>
				</div>
				<div class="fg">
					<img src="@/assets/image/buyProcess/angela.png" />
				</div>
				<div class="buy-item">
					<div class="icon-img"><img src="@/assets/image/buyProcess/icon5.png" /></div>
					<div>
						<div class="title">05-证书打印</div>
						<p>证书可追溯可查询</p>
					</div>
				</div>

			</div>
		</div>
		<!-- <div class="icp" @click="$tool.toOpen('https://beian.miit.gov.cn')">{{ $store.state.system.icp }}</div> -->
		<div class="footer">
			<p>Copyright © 2025 畅度云学 All Rights Reserved<span>|</span>
				<a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">宁ICP备2021002175号</a>
				<span>|</span>
				<img src="@/assets/image/logo/ab.png" />
				<a href="https://beian.mps.gov.cn" rel="noreferrer" target="_blank">宁公网安备64010602001148号</a>
			</p>
		</div>

		<!-- 公告 -->
		<div class="notice" v-if="showNotice" ref="noticeRef">
			<h1>公告</h1>
			<div class="notice-content">
				<!-- <span>{{ formattedContent }}</span> -->
				<p v-for="(paragraph, index) in paragraphs" :key="index" class="paragraph">
					{{ paragraph }}
				</p>
			</div>
			<button @click="closeNotice">确定</button>
		</div>

	</div>
</template>

<script>
// api
import {
	getSubSystemList,
	getMessage
} from '@/api/index'
// 组件
import HeaderLayer from '@/components/layer/HeaderLayer.vue'
import TipsLayer from '@/components/layer/TipsLayer.vue'
// 引入Swiper类和相关模块/样式
import {
	Swiper
} from 'swiper';
import {
	Autoplay
} from 'swiper/modules';
import 'swiper/css';
export default {
	components: {
		HeaderLayer,
		TipsLayer
	},
	data() {
		return {
			propertyByKey: null,
			showVideo: true,
			isPlay: false,
			images: [
				require('@/assets/image/bgImg/1.jpg'),
				// require('@/assets/image/bgImg/3.jpg')
				// 在这里添加更多图片路径
			],
			currentIndex: 0,
			// 平台列表
			swiper: null,
			subSystemArr: null,
			// 公告相关
			showNotice: false,
			noticeAnimation: false
		};
	},
	computed: {
		// 计算函数
		currentImage() {
			return this.images[this.currentIndex];
		},
		paragraphs() {
			// 按句号或换行符分割文本
			return this.propertyByKey
				? this.propertyByKey
					.split(/(?<=[。\n])/) // 分割后保留句号或换行符
					.filter(p => p.trim()) // 过滤空字符串
				: [];
		}
	},
	mounted() {
		// 获取公共信息
		getMessage({
			key: 'info_1505_desc'
		}).then(res => {
			console.log("info_1505_desc", res)
			if (res.result == 1) {
				this.propertyByKey = res.data
				// this.propertyByKey = "根据《专业技术人员继续教育规定》（人社部令第25号）和《自治区人力资源和社会保障厅关于做好2024年职称评审工作的通知》（宁人社函〔2024〕111号），经请示人力资源社会保障部专业技术人员管理司同意，宁夏回族自治区人力资源和社会保障厅对全区专业技术人员继续教育学时结构比例进行调整，专业技术人员参加继续教育每年累计应不少于90学时，其中专业科目一般不少于总学时的2/3，公需科目不少于18学时，其他不变。宁夏畅度教育科技有限公司开展专业技术人员继续教育培训，积极整合优质教育教学资源，构建了完善的继续教育工作体系。通过建立健全专业工作机构、规范管理制度，探索出产学研深度融合的继续教育新模式，充分彰显了继续教育基地的人才培育效能与示范引领作用，为专业技术人才队伍建设注入强劲动力，有力推动区域专业技术人才高质量发展。"
				// 使用自定义的公告组件，而不是Element UI的alert
				this.showNotice = true;
				// 使用$nextTick确保DOM更新后再添加动画类
				this.$nextTick(() => {
					this.noticeAnimation = true;
				});
			}
			// if (res.result == 1) {
			// 	this.propertyByKey = res.data
			// 	this.$alert(res.data, '公告', {
			// 		showConfirmButton: false,
			// 		confirmButtonText: '确定',
			// 		callback: action => {
			// 			// this.$message({
			// 			// 	type: 'info',
			// 			// 	message: `action: ${ action }`
			// 			// });
			// 		}
			// 	});
			// }
		})
		// 展示平台
		this.showSystem()
		// 自动切换背景图	
		this.changeBackgroundImage();
		setInterval(this.changeBackgroundImage, 5000);
	},
	created() {

	},
	methods: {
		// 展示平台
		showSystem() {
			// 初始化swiper
			// this.initSwiper()
			// 获取所有平台
			this.subSystemList()
		},
		// api
		subSystemList() {
			getSubSystemList().then(res => {
				this.subSystemArr = res.data
				// Swiper 更新
				// this.$nextTick(() => {
				// 	this.swiper.update();
				// 	this.swiper.autoplay.start(); // 启动自动播放
				// });
			})
		},
		// 页面方法
		notShowVideo() {
			this.showVideo = false
		},
		toLogin() {
			if (this.$store.state.user.userid) {
				this.$router.push({
					path: '/study'
				}).catch(() => { })
			} else {
				this.$router.push({
					path: '/login'
				}).catch(() => { })
			}
		},
		changeBackgroundImage() {
			try {
				this.currentIndex = (this.currentIndex + 1) % this.images.length;
				// this.$refs.info.style.animation = 'none';
				this.$refs.info.offsetHeight; // 触发重绘
				// this.$refs.info.style.animation = null;
			} catch (e) {
				//TODO handle the exception
			}
		},
		play() {
			if (this.isPlay) {
				this.$refs.video.pause()
				this.isPlay = false
			} else {
				this.$refs.video.play()
				this.isPlay = true
			}
		},
		initSwiper() {
			// 初始化Swiper实例
			this.swiper = new Swiper('.swiper-container', {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 10,
				autoplay: {
					delay: 1500,
					disableOnInteraction: false,
				},
				pagination: {
					clickable: true,
				},
				breakpoints: {
					640: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 50,
					},
				},
				modules: [Autoplay] // 确保你已经导入了这些模块
			});
		},
		handleMouseEnter() {
			// 鼠标进入时暂停自动播放
			this.swiper.autoplay.stop();
		},
		handleMouseLeave() {
			// 鼠标离开时恢复自动播放
			this.swiper.autoplay.start();
		},
		// 公告相关方法
		closeNotice() {
			this.noticeAnimation = false;
			// 使用setTimeout等待动画完成后再隐藏元素
			setTimeout(() => {
				this.showNotice = false;
			}, 100);
		},
	}
};
</script>

<style scoped lang="scss">
.notice {
	position: absolute;
	margin-top: 10%;
	width: 710px;
	max-height: 510px;
	background-image: url('@/assets/image/tips/gg_bg.png');
	border-radius: 20px;
	background-size: cover;

	h1 {
		margin: 40px 0 0 20px;
		color: #0c1045;
		text-align: center;
	}

	.notice-content {
		white-space: pre-line;
		/* 保留换行符并正确显示 */
		background: rgba(255, 255, 255, 0.85);
		border-radius: 10px;
		margin: 20px;
		padding: 20px;
		max-height: 280px;
		overflow-y: scroll;
		line-height: 2;
		color: #333;
		font-size: 16px;
		// text-indent: 2em;
		/* 首行缩进2个字符 */

		.paragraph {
			text-indent: 2em;
			/* 每个段落首行缩进 */
			margin: 0;
			line-height: 2;
		}
	}

	button {
		margin: 20px 0 40px 85%;
		color: #fff;
		background: #2d70ff;
		padding: 10px 30px;
		border-radius: 6px;
		cursor: pointer;
		border: none;

	}
}

.buyProcess {
	width: 70%;
	height: 70px;
	background: #FFFFFF;
	border-radius: 10px;
	padding: 10px;
	display: flex;
	flex-shrink: 0;
	margin: 0 auto 50px;

	.fg img {
		width: 40px;
		height: 40px;

	}

	.buyProcessTitle {
		margin: 8px 20px 0 20px;
		font-weight: bold;
		font-size: 22px;
		color: #000000;
		line-height: 26px;
		font-style: italic;

	}

	.buyProcessContent {
		display: flex;
		justify-content: space-around;
		flex: 1;
		align-items: center;
	}

	.buy-item {
		display: flex;
		align-items: center;
		justify-content: center;

		.icon-img {
			height: 44px;
			width: 44px;
			margin-right: 20px;

			img {
				width: 100%;
			}
		}

		.title {
			font-weight: bold;
			font-size: 20px;
			color: #252525;
		}

		p {
			font-size: 14px;
			color: #666666;
		}
	}

}

.index {
	width: 100%;
	min-height: 100vh;
	background-repeat: no-repeat;
	background-position: center;
	// animation: scaleBackground 7s infinite;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	&>.main-content {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 0;
	}

	&>.main-content>.hero {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0px;
		text-align: center;
	}

	&>.main-content>.hero>.a {
		font-weight: bold;
		font-size: 70px;
		color: #FFFFFF;
	}

	&>.b {
		font-weight: 400;
		font-size: 51px;
		color: #FFFFFF;
		margin-top: 45px;
	}

	&>.main-content>.hero>.c {
		padding: 10px 40px;
		background: #EF4A10;
		border-radius: 104px;
		font-weight: 400;
		font-size: 24px;
		color: #FFFFFF;
		margin-top: 45px;

		&:hover {
			cursor: pointer;
		}
	}

	/* 视频播放窗口样式 */
	/* &>.d {
		border-radius: 10px 10px 0px 0px;
		overflow: hidden;
		width: 440px;
		height: 251px;
		position: fixed;
		left: 54px;
		bottom: 29px;

		&>.video {
			width: 440px;
			height: 251px;
			position: relative;

		}

		&:hover>.hid {
			opacity: 1;
			animation: none;
			//取消动画以确保悬停时显示 
		}

		&>i {
			color: #FFF;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 36px;
			z-index: 999;
			transition: opacity 2s ease-in-out;
			animation: hideElement 1s forwards;

			@keyframes hideElement {
				0% {
					opacity: 1;
				}

				50% {
					opacity: 0.5;
				}

				100% {
					opacity: 0;
				}
			}

			&:hover {
				cursor: pointer;
			}
		}

		&>img {
			width: 15px;
			height: 15px;
			position: absolute;
			right: 10px;
			top: 10px;

			&:hover {
				cursor: pointer;
			}
		}
	} */

	&>.project {
		display: flex;
		// width: 1400px;
		justify-content: center;
		align-items: center;
		margin-top: 200px;

		&>.swiper-container {
			overflow: hidden;

			&>.swiper-wrapper {
				&>.swiper-slide {
					width: 366px !important;
					margin: 20px;
					padding: 20px;
					/*height: 124px !important;*/
				}

				&>.projectItem {
					width: 366px;
					height: 78px;
					background: #FFF;
					border-radius: 16px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 0px 20px;

					&:hover {
						cursor: pointer;
					}

					&>div:nth-child(1) {
						&>span {
							font-weight: 500;
							font-size: 18px;
							color: #333333;
						}
					}

					&>div:nth-child(2) {
						&>img {
							height: 40px;
						}
					}
				}
			}
		}
	}

	&>.icp {
		position: absolute;
		text-align: center;
		bottom: 20px;
		font-weight: 300;
		font-size: 14px;
		color: #F1ECEC;

		&:hover {
			cursor: pointer;
		}
	}

	&>.tip {
		position: fixed;
		right: 20px;
		bottom: 28px;
		z-index: 999;
	}

	.footer {
		position: fixed;
		z-index: 99999999999;
		/* background: #f00; */
		bottom: 20px;
		margin: 0 auto;
		left: 0;
		right: 0;
		text-align: center;
		color: #999aaa;
		font-size: 14px;
	}
	.footer p {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.footer img {
		width: 18px;
		margin-right: 5px;
	}
	.footer p a {
		color: #999aaa;
		text-decoration: none;
	}

	.footer p span {
		color: #999aaa;
		text-decoration: none;
		margin: 0px 10px;
	}


}

@keyframes scaleBackground {
	0% {
		background-size: 140%;
	}

	100% {
		background-size: 110%;
	}
}
</style>